import React, { useState } from 'react'
import {
  Button,
  ButtonBase,
  Dialog,
  DialogActions,
  DialogTitle,
  makeStyles
} from '@material-ui/core'
import { BASE_COLORS, GRAY_COLORS } from 'asterX-UI'
import { colorStatusesByCode, OKTELL } from 'constants/deals'
import { useResErrors, useRoutes } from 'hooks'
import { DEAL_VIEW_PATH, HOME_PATH } from 'routes/constants.routes'
import { useWorkListStoreManager } from 'context/HomeStore/Manager/WorkListsProvider/WorkListProvider.manager'
import { SalesService } from 'lib/api'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
    gap: 8,
    width: '100%',
    backgroundColor: BASE_COLORS.White,
    borderRadius: 12,
    marginTop: 12
  },
  row: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8
  },
  idWl: {
    color: GRAY_COLORS[700],
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    fontFamily: 'Inter'
  },
  chip: {
    padding: '2px 8px',
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '18px'
  },
  text: {
    color: GRAY_COLORS[700],
    fontSize: 14,
    fontWeight: 400,
    fontFamily: 'Inter'
  }
}))

const Card = ({ workList }) => {
  const classes = useStyles()
  const { goTo } = useRoutes()
  const { workListStore, workListStoreFunc } = useWorkListStoreManager()
  const { standardCheck } = useResErrors()

  const [isWorksheetAssignedOpen, setIsWorksheetAssignedOpen] = useState(false)

  const toggleAssignedOpen = () => {
    setIsWorksheetAssignedOpen(prevState => !prevState)
  }

  const isThisTab = checkedTab => checkedTab === workListStore.selectedTab

  const handleClick = () => {
    if (isThisTab(OKTELL)) {
      workListStoreFunc.setLoading(true)

      SalesService.getSaleByIdForView(workList.id)
        .then(response =>
          standardCheck(response, () => {
            if (response.data?.assignTo) toggleAssignedOpen()
            else goTo(`${HOME_PATH}${DEAL_VIEW_PATH}/${workList.id}`)
          })
        )
        .then(() => workListStoreFunc.setLoading(false))
    } else goTo(`${HOME_PATH}${DEAL_VIEW_PATH}/${workList.id}`)
  }

  return (
    <ButtonBase classes={{ root: classes.root }} onClick={handleClick}>
      <div className={classes.row}>
        <div className={classes.idWl}> {workList.globalId}</div>

        <div
          className={classes.chip}
          style={colorStatusesByCode(workList?.saleStatus?.code)}
        >
          {workList?.saleStatus?.name}
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.text}>{workList?.client?.firstName}</div>
        <div className={classes.text}>
          {workList.selectedCarsForSale?.[0]?.vin || '-'}
        </div>
      </div>

      <Dialog open={isWorksheetAssignedOpen} onClose={toggleAssignedOpen}>
        <DialogTitle>РЛ уже взят в работу другим менеджером</DialogTitle>

        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={toggleAssignedOpen}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </ButtonBase>
  )
}

export default Card
